import styled from 'styled-components';

export const StyledSpaceGoBalance = styled.div`
    display: inline-flex;
    align-items: center;
    font-weight: 400;
    padding: 4px 8px;
    margin-right: 4px;
    background: #090535;
    border: 1px solid rgba(78, 194, 246, 1);
    border-radius: 16px;
    color: rgba(247, 212, 39, 1);
    font-size: 18px;
    font-family: 'Mouse Memoirs', sans-serif;
    margin-top: 8px;

    .balanceImg {
        height: 20px;
        aspect-ratio: 1/1;
        margin-right: 4px;
        background-color: transparent;
    }
`;
